import React, {Component, useEffect} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Link, Redirect, Route } from 'react-router-dom';
import OrderDetails from "../Order/orderDetails";
import OrderCollection from "./orderCollection";
import {_axios} from '../../plugins/axios';
import { URL,USER } from "../../constants/constant";
import Button from 'react-bootstrap/Button';
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import orderDetailsCollected from "./orderDetailsCollected";
import { decrptor, maskingAdhaar, maskPassportVID } from "../common/regex";
import auth from "../../auth/auth";

class OrderDashboard extends Component{
  constructor(props){
    super(props);
    console.log(this.props);
    this.pendingCompletedToogle = true;
    this.state = {
        userdata : USER.user,
        orderStatus : null,
        activeTab : this.props.match.params.orderStatus ? this.props.match.params.orderStatus : 'pending',
        pendingCaseCount : null,
        completedCaseCount : null,
        ordersList : null,
        orderStatusId: this.props.match.params.orderStatus ? this.props.match.params.orderStatus == 'pending' ? 'pending' : 'sample collected' : 'pending',
        todayTomorrowMsg : null,
        todaySubMsg : null,
        createOrderRedirectURL: '',
        selectedSample : null,
        messageSnack: "",
        showSnack: false,
    }
  }

  componentWillReceiveProps(nextProps) {
      console.log("nextProps",nextProps)
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.match.params.orderStatus !== this.state.activeTab) {
      this.setState({ 
          activeTab: nextProps.match.params.orderStatus ? nextProps.match.params.orderStatus : 'pending', 
          orderStatusId: nextProps.match.params.orderStatus == 'pending' ? 'pending' : 'sample collected'
        });
    }
  }
  removeLocalStorage(){
    localStorage.removeItem('customer_phoneNumber');
    localStorage.removeItem('upsellMemberDetailsConfirm');
    localStorage.removeItem('orderTestDetails');
    localStorage.removeItem('upsellOrderIds');
    localStorage.removeItem('order_details');
    localStorage.removeItem('lab_technician_number');
    localStorage.removeItem('phlebo_start_order_trip_details');
    localStorage.removeItem('AppointmentDate');
    localStorage.removeItem('AppointmentId');
    localStorage.removeItem('City');
    localStorage.removeItem('DID');
    USER.orderDetails = null;
  }

  getCreateOrderURL() {
    const that = this;
    _axios.post("https://affiliate.medibuddy.in/upsell/getUpsellUrl", {}, {
      headers: {
        source: "phleboapp"
      }
    }).then(function(res) {
      if(res.data.isSuccess) {
        that.setState({
          createOrderRedirectURL: res.data.upsellUrl
        });
      }
    }).catch(function(err) {
      console.log(err)
    })
  }

  componentDidMount(){
      if(!localStorage.getItem('access_token')){

        if (this.props.match.params.token != undefined) {
          console.log("Token --->", this.props.match.params.token);
          console.log("Token --->", JSON.stringify(this.props.match.params.token));
          let that = this;
          let url = URL.dev_url;
          let route = url + 'verifyotp'  
          
          let body  = {
              isCheckToken: true,
              token: this.props.match.params.token,
          }
          _axios.post(route,
              body)
          .then(function (response) {
            console.log(response);
                if(response.data.success || response.data.isSuccess){
                    if(response.data.message){
                      
                        that.showAlert(`${response.data.message}`, 2500);
                        auth.login(() => {
                          // that.removeLocalStorage();
                          localStorage.setItem("access_token",that.props.match.params.token);
                          localStorage.setItem("user_details",JSON.stringify(response.data.userdetails));
                          localStorage.setItem("isAndroidLogin", true);
                          USER.user = response.data.userdetails;
                          /// -------------------------------
                          that.props.history.push("/orders");
                          
                      });

                    
                    }else if(!response.data.message){
                      this.showAlert("Invalid Tokken Passed!", 2500);
                    }
                }
            }).catch(function (error) {
                that.showAlert(`${error}`, 2500);
                console.log(error);
            })
        } else {
          console.log("this is working");
          // this.props.history.push('./login')
        }

      } else {
        this.removeLocalStorage();
        USER.user = localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")) : null;
        let featureConfig = USER.user.featureConfig ? JSON.parse(USER.user.featureConfig) : null;
        if(featureConfig?.isNewUpsellFlowLive){
          this.props.history.push("/dependantOrders");
        }
        // console.log(USER.user);
        this.getOrders();
        this.getCreateOrderURL();
      }   
  }

  componentDidUpdate (prevProps, prevState) {
    
    if (prevState.selectedSample != this.state.selectedSample) {
      console.log("Update the page!!");
      this.getOrders();
    }
      
  } 


  getPendingCompletedCases(){
    let pendingCase = this.state.pendingOrders ? this.state.pendingOrders.length : 0;
    let sampleTakenCase = this.state.sampleTakenOrders ? this.state.sampleTakenOrders.length : 0;
    let completedCase = this.state.completedOrders ? this.state.completedOrders.length : 0;
   
    this.setState({
        pendingCaseCount : pendingCase+sampleTakenCase,
        completedCaseCount : completedCase
    })
  }
  getOrders(){
     const that = this;
     let url = URL.dev_url;
     let route = url + 'getorders'
     let obj = {
        phleboId: this.state.userdata ? this.state.userdata.phleboId :  JSON.parse(localStorage.getItem("user_details")).phleboId
     }

     _axios.post(route,obj)
     .then(function (response) {
        let orders  = [
          ...response.data.pendingOrders.sort((a,b) => new Date(a.orderDateTime) - new Date(b.orderDateTime)), 
          ...response.data.sampleTakenOrders.sort((a,b) => new Date(a.orderDateTime) - new Date(b.orderDateTime))
        ];
        that.setState({
            pendingOrders : response.data.pendingOrders,
            sampleTakenOrders : response.data.sampleTakenOrders,
            completedOrders : response.data.completedOrders,
            todayTomorrowMsg : response.data.todayTomorrowMsg,
            todaySubMsg : response.data.todaySubMsg
        },()=>{
           that.getPendingCompletedCases();
           console.log("state,",that.state);
        })

     }).catch(function (error) {
         console.log(error);
     })
  }


  renderRedirect = (orderstatus) => {
        let x =  '/orders/' +orderstatus;
        this.props.history.push(x);
  }

  redirectToSample(elem,id){
        if(elem.orderStatus.currentStatusId == 4 || elem.orderStatus.currentStatusId == 111){
          let routerLink = '/sample/collected/'+id;
          this.props.history.push(routerLink);
          <Route path={routerLink} component={OrderCollection}/>
        } else if ([5,51,6,7,8,9,10,11,12].includes(elem.orderStatus.currentStatusId)) {
          let routerLink = '/sample/collectedCompleted/'+id;
          this.props.history.push(routerLink);
          <Route path={routerLink} component={orderDetailsCollected}/>
        }
        else {
        let routerLink = '/sample/'+id;
        this.props.history.push(routerLink);
        <Route path={routerLink} component={OrderDetails}/>}
  }
  
  routeToLab(id){
    let skip = false
    if (skip) { //skipOtpState
      if (sampleData !== null) {
          sampleData = sampleData.filter(i => i.orderStatus.currentStatusId === 6)

          if (sampleData.length === 0 ) {
            console.log("snackBar");

            setTimeout(() => {
              that.showAlert("Please complete mandatory OTP verification step to proceed to drop sample.", 2500);
            })
            
            
          } else {
            console.log("this ran!");
            let routerLink = '/labs';
            this.props.history.push(routerLink);
          }
      } else {
        setTimeout(              () => {
          that.showAlert("No orders available to be submitted!", 2500);
        })     
      }
  } else {
    let routerLink = '/labs';
    this.props.history.push(routerLink);
  }


  }

  redirectToUpsell() {
    if(this.state.createOrderRedirectURL) {
      window.location.href = this.state.createOrderRedirectURL;
    }
  }

formatTodayTomorrow(date) {
  let currentDate = new Date();
  let tomorrowsDate = new Date()
  tomorrowsDate.setDate(tomorrowsDate.getDate() + 1);

  if (currentDate.getDate() == date.getDate()) {
      return "Today";
  } else if (tomorrowsDate.getDate() == date.getDate()) {
      return "Tomorrow";
  } else {
    return "";
  }
}

formatDate(date) {
  const months = ["JAN", "FEB", "MAR","APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  return  date.getDate() + "-" + months[date.getMonth()] + "-" + date.getFullYear();
}

formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    strTime = this.formatDate(date) + ', ' + strTime;
    return strTime;
}

showAlert(message, timeout) {
  this.setState({
      messageSnack: message,
      showSnack: true
  });
  setTimeout(() => {
      this.setState({
          messageSnack: "",
          showSnack: false,
      })
  }, timeout);
}

callbackForMembers = (result) => {

  console.log(result);

  
  this.showAlert(result.message, 2500);
  this.getOrders();

}

showPendingCases(){
          return( <div>
        {          
          this.state.pendingOrders ? this.state.pendingOrders.map((elem,index) => ( 
            
            <div>
              {/* <div className="card-strip" style={{
                backgroundColor: `#CC${elem.color.split('#')[1]}`,
                boxShadow: `#CC${elem.color.split('#')[1]} 0px -1px 2px 2px`}}>
              </div> */}
              
              <div key={index}  className="card-box" 
              style={{boxShadow: `#CC${elem.color.split('#')[1]} 0px -4px 0px 2px , #CC${elem.color.split('#')[1]} 0px 0px 0px 2px `}}
              >

                  <div className="display-flex justify-content-space-between">
                  <Container>
                  
                      <Row >

                        
                          <Col md={6} xs={12}>
                            <div className="font-size-sm bold p-b-10 width-100"><div className={`badge-custom-${elem.orderStatus.currentStatusId}`}>{elem.orderStatus.statusMessage}</div> </div>
                          </Col>

                          {
                          (elem.tests[0].testType != null
                          && elem.tests[0].testType != undefined
                          && elem.tests[0].testType != "") &&
                          <Col md={3} xs={6} className="justify-content-start">
                            <div className="font-size-sm bold p-b-10 width-100"><div className="badge-custom-dark-grey"> {elem.tests[0].testType}</div> 
                            </div>  
                          </Col>
                          }

                          {(elem.isUpsell) && 
                          <Col md={3} xs={6} className="display-flex justify-content-md-end justify-content-xs-start">
                            <div className="font-size-sm bold p-b-15 width-100"><div className="badge-custom-green"> Upsell </div> </div> 
                          </Col>
                          }

                        </Row>
                        
                        <Row>   
                          <div className="p-t-10 width-100"> 
                              <b>DID :</b>  <b><span className=" base-color">{elem.dependantId ? elem.dependantId: "NA" }</span></b>
                          </div>
                        </Row>
                      <Row>
                        <div className="p-b-10 width-100 position-relative"> 
                          <b>{elem.patientDetails[0].name}</b> 
                            
                          <span className=" m-r-5">{" (Age: " + ((elem.patientDetails[0].patientAge != null) ? elem.patientDetails[0].patientAge : "NA")
                          + " Gender: " + ((elem.patientDetails[0].patientGender != null) ? elem.patientDetails[0].patientGender : "NA")
                          + ")" 
                          }</span>
                        </div>
                      </Row>
                  </Container>
                    
                  </div>

                  <div onClick={(e)=> this.redirectToSample(elem,elem.orderId,e)}>

                    {decrptor(elem.patientDetails[0].aadharNumber) &&
                      <div className="p-b-10 width-100">  
                        <b>Aadhaar No:</b> {maskingAdhaar(decrptor(elem.patientDetails[0].aadharNumber))} 
                      </div>
                    }
                    {decrptor(elem.patientDetails[0].passPort) &&
                      <div className="p-b-10 width-100">  
                        <b>Passport No / Voter ID:</b> {maskPassportVID(decrptor(elem.patientDetails[0].passPort))} 
                      </div>
                    }

                    <div className="p-b-10 width-100">  
                        <b>Order :</b> {elem.prOrderId} (Request : {elem.appointmentId})
                    </div>
                    {(typeof elem.patientDetails[0].priority == "string"
                    && elem.patientDetails[0].priority != "") ? (
                    <div className="p-b-10 width-100"> 
                            <b>Priority :</b> {elem.patientDetails[0].priority}
                    </div>
                    )
                    : ""}

                    {(typeof elem.patientDetails[0].corporateName == "string"
                    && elem.patientDetails[0].corporateName != "") ? (
                    <div className="p-b-10 width-100"> 
                            <b>Corporate :</b> {elem.patientDetails[0].corporateName}
                    </div>
                    )
                    : ""}

                  
                    <div className="width-100 display-flex p-b-10">
                          <i className="fa fa-clock-o width-5 margin-auto-zero" aria-hidden="true"></i> 
                            <span className="p-l-10">{this.formatAMPM(new Date(elem.orderDateTime))}</span>
                      </div>
                      
                    <div> <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i> {elem.patientDetails[0].city} - {elem.patientDetails[0].pincode} </div>
                  </div>
                  
              </div> 

            </div> 
              
            )): ''
            }
             {
              this.state.sampleTakenOrders ? this.state.sampleTakenOrders.map((elem,index) => ( 

                <div>
                  {/* <div className="card-strip" style={{backgroundColor: `${elem.color}`}}>
                  </div>                        */}
                    <div key={index} className="card-box"  
                    style={{boxShadow: `#CC${elem.color.split('#')[1]} 0px -4px 0px 2px , #CC${elem.color.split('#')[1]} 0px 0px 0px 2px `}}>
                      <div className="display-flex justify-content-space-between">
                      <Container>
                            <Row>
                              
                              {
                              (elem.tests[0].testType != null
                              && elem.tests[0].testType != undefined
                              && elem.tests[0].testType != "") &&
                              <Col md={3} xs={6} className="justify-content-start">
                                <div className="font-size-sm bold p-b-10 width-100"><div className="badge-custom-dark-grey"> {elem.tests[0].testType}</div> 
                                </div>  
                              </Col>
                              }

                              <p>&nbsp;&nbsp;</p>
                              <div className="font-size-sm bold p-b-10 width-40"><div className={`badge-custom-${elem.orderStatus.currentStatusId}`}>{elem.orderStatus.statusMessage}</div> </div> 
                              
                            </Row>
                            <Row>   
                              <div className="p-t-10 width-100"> 
                                  <b>DID :</b>  <b><span className=" base-color">{elem.dependantId ? elem.dependantId: "NA" }</span></b>
                              </div>
                            </Row>
                            <Row>
                              <div className="width-100 position-relative">
                                <b>{elem.patientDetails[0].name}</b>
                               <span className=" m-r-5"> {" (Age: " + ((elem.patientDetails[0].patientAge != null) ? elem.patientDetails[0].patientAge : "NA")
                                + " Gender: " + ((elem.patientDetails[0].patientGender != null) ? elem.patientDetails[0].patientGender : "NA")
                                + ")" 
                              } </span>
                              </div>
                            </Row>
                        </Container>

                      </div>

                      <div onClick={(e)=> this.redirectToSample(elem,elem.orderId,e)}>

                         {decrptor(elem.patientDetails[0].aadharNumber) &&
                          <div className="p-b-10 width-100">  
                            <b>Aadhaar No:</b> {maskingAdhaar(decrptor(elem.patientDetails[0].aadharNumber))} 
                          </div>
                        }
                        <div className="p-b-10 width-100"> 
                            <b>Order :</b> {elem.prOrderId} (Request : {elem.appointmentId})
                        </div>

                        {(typeof elem.patientDetails[0].priority == "string"
                          && elem.patientDetails[0].priority != "") ? (
                          <div className="p-b-10 width-100"> 
                                  <b>Priority : </b>{elem.patientDetails[0].priority}
                          </div>
                          )
                          : ""}

                          {(typeof elem.patientDetails[0].corporateName == "string"
                          && elem.patientDetails[0].corporateName != "") ? (
                          <div className="p-b-10 width-100"> 
                                  <b>Corporate :</b> {elem.patientDetails[0].corporateName}
                          </div>
                          )
                          : ""}

                        <div> <i className="fa fa-clock-o width-5" aria-hidden="true"></i> {this.formatAMPM(new Date(elem.orderDateTime))} </div>
                        <div> <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i> {elem.patientDetails[0].city} - {elem.patientDetails[0].pincode} </div>

                      </div>

                  </div>   
                </div>
                        
            )): ''
            }

            
           </div>
            )
      }

      


showCompletedCases(){
      return( <div>
              {
                this.state.completedOrders ? this.state.completedOrders.map((elem,index) => (  
                  
                    <div>
                      {/* <div className="card-strip" style={{backgroundColor: `${elem.color}`}}>
                      </div>  */}
                      <div key={index} className="card-box"  onClick={(e)=> this.redirectToSample(elem,elem.orderId,e)}
                      style={{boxShadow: `#CC${elem.color.split('#')[1]} 0px -4px 0px 2px , #CC${elem.color.split('#')[1]} 0px 0px 0px 2px `}}>
                        <div className="display-flex justify-content-space-between">
                        <Container>
                          <Row>
                                <Col md={6} xs={12}>
                                  <div className="font-size-sm bold p-b-10 width-100"><div className={`badge-custom-${elem.orderStatus.currentStatusId}`}>{elem.orderStatus.statusMessage}</div> </div>
                                </Col>

                                {(elem.tests[0].testType != null
                                && elem.tests[0].testType != undefined
                                && elem.tests[0].testType != "") &&
                                <Col md={3} xs={6}>
                                  <div className="font-size-sm bold p-b-10 width-60"><div className="badge-custom-dark-grey"> {elem.tests[0].testType}</div> </div> 
                                </Col>}

                                {(elem.isUpsell) &&
                                <Col md={3} xs={6} className="display-flex justify-content-end">
                                
                                  <div className="font-size-sm bold p-b-15 width-60"><div className="badge-custom-green"> Upsell </div> </div> 
                                  
                                </Col>}


                              </Row>
                              <Row>   
                                <div className="p-t-10 width-100"> 
                                    <b>DID :</b>  <b><span className=" base-color">{elem.dependantId ? elem.dependantId: "NA" }</span></b>
                                </div>
                              </Row>
                            <Row>
                            <div className="p-b-10"> 
                                <b>{elem.patientDetails[0].name}</b>
                                {" (Age: " + ((elem.patientDetails[0].patientAge != null) ? elem.patientDetails[0].patientAge : "NA")
                              + " Gender: " + ((elem.patientDetails[0].patientGender != null) ? elem.patientDetails[0].patientGender : "NA")
                              + ")" 
                              } 
                            </div>
                            {
                              (elem.orderStatus.currentStatusId == 31) ? <div className="font-size-sm bold p-b-10 width-40"><div className="badge-custom-red"> Rescheduled </div> </div> : ''
                            }
                          
                            </Row>
                        </Container>

                        {decrptor(elem.patientDetails[0].aadharNumber) &&
                          <div className="p-b-10 width-100">  
                            <b>Aadhaar No:</b> {maskingAdhaar(decrptor(elem.patientDetails[0].aadharNumber))} 
                          </div>
                        } 
                        </div>
                          <div className="p-b-10 width-100"> 
                            <b>Order :</b> {elem.prOrderId} (Request : {elem.appointmentId})
                          </div>
                          {(typeof elem.patientDetails[0].priority == "string"
                        && elem.patientDetails[0].priority != "") ? (
                        <div className="p-b-10 width-100"> 
                                <b>Priority : </b>{elem.patientDetails[0].priority}
                        </div>
                        )
                        : ""}

                        {(typeof elem.patientDetails[0].corporateName == "string"
                        && elem.patientDetails[0].corporateName != "") ? (
                        <div className="p-b-10 width-100"> 
                                <b>Corporate :</b> {elem.patientDetails[0].corporateName}
                        </div>
                        )
                        : ""}

                        <div> <i className="fa fa-clock-o width-5" aria-hidden="true"></i> {this.formatAMPM(new Date(elem.orderDateTime))} </div>
                        <div> <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i> {elem.patientDetails[0].city} - {elem.patientDetails[0].pincode} </div>
                      </div>  
                    </div>
              )): ''
              }
             </div>
      )
}


getAllOrders () {
  return (
    <div className="order-dashboard">
          <Container>
          <Row>
                <Button variant="primary" size="lg" block className="m-10 border-curve-10" onClick={()=> this.redirectToUpsell()}>
                            Create New Order
                  </Button>

              </Row>
                <Row>
                    <Col md={4}></Col>
                    <Col xs={12} md={4}>
                        <div className="heading text-align-center font-size-lg bold p-b-10">
                            Your Orders
                        </div>
                    </Col>
                    <Col md={4}></Col>
                 </Row>

                 <Row className="p-t-15 font-size-md p-b-10">
                    <Col md={3}></Col>
                    <Col xs={6} md={3}>
                        <div className="order-status-card-btn text-align-center" onClick={() => this.renderRedirect('pending')}>
                            <div className={`p-10 ${this.state.activeTab == 'pending' ? "active" : "non-active"}`}>
                                <div>
                                   {this.state.pendingCaseCount}
                                </div>
                                Pending
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className="order-status-card-btn text-align-center" onClick={() => this.renderRedirect('completed')}>
                            <div className={`p-10 ${this.state.activeTab == 'completed' ? "active" : "non-active"}`}>
                                    <div>
                                    {this.state.completedCaseCount}
                                    </div>
                                    Completed
                            </div>
                        </div>
                    </Col>
                    <Col md={3}></Col>
                 </Row>

                 <Row>
                    <Col md={4}></Col>
                    <Col xs={12} md={4}>
                        <div className="heading text-align-center font-size-md p-t-10 p-t-10 uppercase">
                            {this.state.activeTab == 'completed' ? "Completed Cases" : ""}
                        </div>
                        {this.state.activeTab == 'pending' ?
                          <div  className="p-b-5 deep-pink-color text-align-center font-size-ml bold">
                                {this.state.todayTomorrowMsg}
                          <br/>
                          <span  className="p-b-5 deep-pink-color text-align-center font-size-smd">
                                {this.state.todaySubMsg} 
                          </span>
                        </div>
                        : "" }
                    </Col>
                    <Col md={4}></Col>
                 </Row>

                 <div className="card-list">
                    { 
                    (this.state.activeTab == 'pending') ? this.showPendingCases() : this.showCompletedCases()
                    }
                 </div>
            </Container>

            <Container>
                      <Row>
                        { 
                        (this.state.activeTab == 'pending' &&  (this.state.sampleTakenOrders ? this.state.sampleTakenOrders.length > 0 : false)) ? 
                            <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
                            <Button variant="primary" size="lg" block className="border-curve-10" onClick={()=> this.routeToLab(this.props.match.params.orderId)}>
                            Drop Samples at Lab
                            </Button>
                        </div>
                        : ''
                        }
                      </Row>
                  </Container>
        </div>
  )
}

  render(){
    return(
      <div>
        {this.state.showSnack ? <div className="snackbar show">{this.state.messageSnack}</div> : ''}
        <div>      
          {this.getAllOrders()}
        </div>
      </div>

    )
    }
}
export default OrderDashboard;
